import { ColumnTypes } from './interfaces';

export const NEW_GROUP_ID = 'temprary';

export const defaultColumns: (ColumnTypes[number] & { editable?: boolean; dataIndex: string; required?: boolean })[] = [
  {
    title: 'table.colName',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    editable: true,
    required: true,
  },
  {
    title: 'table.colCluster',
    dataIndex: 'cluster',
    key: 'cluster',
    ellipsis: true,
    editable: true,
  },
  {
    title: 'table.colTotal',
    dataIndex: 'total_users',
    key: 'total_users',
    ellipsis: true,
  },
];
